import { Navigate, useSearchParams } from 'react-router-dom';

/**
 * 管理员登录已并入主登录页的「药丸账号」Tab（管理员 = 药丸白名单）。
 * 保留该路由做兼容跳转，带上下一个目标地址。
 */
export default function AdminLogin() {
  const [searchParams] = useSearchParams();
  const next = searchParams.get('next');
  const safeNext = next && next.startsWith('/') && !next.startsWith('//') ? next : null;
  const target = safeNext
    ? `/login?tab=pill&next=${encodeURIComponent(safeNext)}`
    : '/login?tab=pill';
  return <Navigate to={target} replace />;
}
